import React from 'react';
import PropTypes from 'prop-types';
import Invite from './Invite';
import Modal from './Modal';
import './InviteModal.css';

export default function InviteModal(props) {
  const onRequestClose = props.isLoading ? () => {} : props.onRequestClose;
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={onRequestClose}
      className="invite-modal"
      showCloseButton={!props.isLoading}
    >
      <Invite {...props} />
    </Modal>
  );
}

InviteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  ...Invite.PropTypes
};



// WEBPACK FOOTER //
// ./src/components/InviteModal.js